export const worker = {
    start() {}
};